var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pmbetslip",
      class: [
        {
          "betslip-empty":
            !_vm.bsPool ||
            (Object.values(_vm.selectedSRRunners).length === 0 &&
              Object.values(_vm.selectedMRRunners).length === 0)
        },
        { loggedin: _vm.isLoggedIn }
      ]
    },
    [
      !_vm.bsPool ||
      (Object.values(_vm.selectedSRRunners).length === 0 &&
        Object.values(_vm.selectedMRRunners).length === 0)
        ? _c("div", { staticClass: "emptyBetSlip" }, [
            _vm.brandLayout !== "generic"
              ? _c(
                  "div",
                  { staticClass: "add-bets-container" },
                  [
                    _c("v-icon", [_vm._v("add")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "ab-info-msg" }, [
                      _c("span", { staticClass: "ab-label" }, [
                        _vm._v(_vm._s(_vm.$t("BetSlip.add.bets")))
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "ab-label zerobets",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("BetSlip.zero.bets"))
                        }
                      })
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.brandLayout === "generic"
              ? _c("div", { staticClass: "empty-betslip-container" }, [
                  _c("img", {
                    staticClass: "empty_betslip",
                    attrs: {
                      src: _vm.mediaServer(
                        "/static/brand-img/" +
                          _vm.brandKey +
                          "/empty-betslip.svg"
                      ),
                      alt: "Betslip"
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "betslip_actions" },
              [
                _c("geolocation-indicator"),
                _vm._v(" "),
                !_vm.placeBetStatus && !_vm.isLoggedIn
                  ? _c("div", { staticClass: "pmbs-btnctrls" }, [
                      _c("div", { staticClass: "action-btns emptybetslip" }, [
                        _c(
                          "div",
                          { staticClass: "pmbs-btnctrls-group tac" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "placebetbtn",
                                attrs: {
                                  color: "primary",
                                  id: "btnLogInAndPlaceBet"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.popUpLogIn()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("BetSlip.btn.msg.LogIn")))]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        : [
            _c(
              "div",
              { staticClass: "betslip-content-holder" },
              [
                _vm.bsPool && _vm.meeting && !_vm.placeBetStatus
                  ? _c("div", { staticClass: "betslip-content" }, [
                      _c(
                        "div",
                        { staticClass: "pmbs-bethead pmbs-block clearafter" },
                        [
                          _c("div", { staticClass: "meeting-name" }, [
                            _vm._v(_vm._s(_vm.meeting.name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "meeting-date" }, [
                            _vm._v(
                              _vm._s(_vm.filterMeetingDate(_vm.meeting.date))
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.bsPool.category === "RUNNER POOL"
                        ? _c("div", [
                            _c("div", { staticClass: "pmbs-block" }, [
                              _c(
                                "div",
                                { staticClass: "pmbs-bettitle clearafter" },
                                [
                                  _vm._v(
                                    "\n              Race # " +
                                      _vm._s(_vm.selectedSRTote.race.number) +
                                      "\n              "
                                  ),
                                  _vm.selectedSRTote.race.usc === "ON"
                                    ? _c(
                                        "span",
                                        {
                                          class:
                                            "racetimeticker " +
                                            _vm.pmRaceClockCalculate(
                                              _vm.selectedSRTote.race.tsstart,
                                              _vm.selectedSRTote.timestamp
                                            ).cssclass,
                                          staticStyle: { float: "right" },
                                          attrs: {
                                            "data-racetsstart":
                                              _vm.selectedSRTote.race.tsstart,
                                            "data-racedatastamp":
                                              _vm.selectedSRTote.timestamp,
                                            "data-raceusc":
                                              _vm.selectedSRTote.race.usc
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.pmRaceClockCalculate(
                                                _vm.selectedSRTote.race.tsstart,
                                                _vm.selectedSRTote.timestamp
                                              ).timetostarts
                                            )
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "racetimeticker racetime-over",
                                          staticStyle: { float: "right" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.selectedSRTote.race.gsc)
                                          )
                                        ]
                                      )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "pmbs-rnrgroup" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "pmbs-rnrgrouptitle clearafter"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.bsPool && _vm.bsPool.type
                                          ? _vm.pmTranslatePoolType(
                                              _vm.bsPool.type
                                            )
                                          : "-"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "pmbs-rnrgrouprnrs" },
                                  _vm._l(_vm.selectedSRRunners, function(
                                    rnrdata
                                  ) {
                                    return rnrdata &&
                                      rnrdata.finishes &&
                                      rnrdata.finishes.has(0)
                                      ? _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouprnr" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  "silknum silknum-" +
                                                  Math.floor(rnrdata.runner.num)
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    rnrdata.runner.entrynumber
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.makeSrRunnerName(
                                                    rnrdata.runner
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass: "but-remove",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeSRSelection(
                                                      rnrdata.runner.id,
                                                      0
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("icon", {
                                                  attrs: {
                                                    name: "icon-trash-grey"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  }),
                                  0
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.bsPool.category === "RACECAST POOL"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "pmbs-block" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pmbs-bettitle clearafter" },
                                  [
                                    _vm._v(
                                      "\n              Race # " +
                                        _vm._s(_vm.selectedSRTote.race.number) +
                                        "\n              "
                                    ),
                                    _vm.selectedSRTote.race.usc === "ON"
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              "racetimeticker " +
                                              _vm.pmRaceClockCalculate(
                                                _vm.selectedSRTote.race.tsstart,
                                                _vm.selectedSRTote.timestamp
                                              ).cssclass,
                                            staticStyle: { float: "right" },
                                            attrs: {
                                              "data-racetsstart":
                                                _vm.selectedSRTote.race.tsstart,
                                              "data-racedatastamp":
                                                _vm.selectedSRTote.timestamp,
                                              "data-raceusc":
                                                _vm.selectedSRTote.race.usc
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.pmRaceClockCalculate(
                                                  _vm.selectedSRTote.race
                                                    .tsstart,
                                                  _vm.selectedSRTote.timestamp
                                                ).timetostarts
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "racetimeticker racetime-over",
                                            staticStyle: { float: "right" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.selectedSRTote.race.gsc
                                              )
                                            )
                                          ]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.bsPool && _vm.bsPool.type
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "pmbs-bettitle bettypetitle clearafter"
                                      },
                                      [
                                        _vm.bsBetType === "NO_OPTION"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pmTranslatePoolType(
                                                    _vm.bsPool.type
                                                  )
                                                )
                                              )
                                            ]
                                          : _vm.bsBetType === "STRAIGHT"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pmTranslatePoolType(
                                                    _vm.bsPool.type
                                                  )
                                                )
                                              )
                                            ]
                                          : _vm.bsBetType === "PERMUTATION"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pmTranslatePoolType(
                                                    _vm.bsPool.type
                                                  )
                                                ) + " BOX"
                                              )
                                            ]
                                          : _vm.bsBetType === "BANKER"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pmTranslatePoolType(
                                                    _vm.bsPool.type
                                                  )
                                                ) + " KEY"
                                              )
                                            ]
                                          : _vm.bsBetType === "FLOATING_BANKER"
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.pmTranslatePoolType(
                                                    _vm.bsPool.type
                                                  )
                                                ) + " KEY BOX"
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.bsPool.nooflegs4pooltype, function(
                                  legN,
                                  legIx
                                ) {
                                  return _vm.bsBetType === "STRAIGHT"
                                    ? _c(
                                        "div",
                                        { staticClass: "pmbs-rnrgroup" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "pmbs-rnrgrouptitle"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Betslip.PM.PositionPlace",
                                                    { n: _vm.position[legN] }
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "pmbs-rnrgrouprnrs"
                                            },
                                            [
                                              Object.values(
                                                _vm.selectedSRRunners
                                              ).filter(function(rnrdata) {
                                                return rnrdata.finishes.has(
                                                  legN
                                                )
                                              }).length === 0
                                                ? _c("div", [_vm._v(" ")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.selectedSRRunners,
                                                function(rnrdata) {
                                                  return rnrdata &&
                                                    rnrdata.finishes &&
                                                    rnrdata.finishes.has(legN)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pmbs-rnrgrouprnr"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class:
                                                                "silknum silknum-" +
                                                                Math.floor(
                                                                  rnrdata.runner
                                                                    .num
                                                                )
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rnrdata.runner
                                                                    .entrynumber
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.makeSrRunnerName(
                                                                  rnrdata.runner
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "but-remove",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeSRSelection(
                                                                    rnrdata
                                                                      .runner
                                                                      .id,
                                                                    legN
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c("icon", {
                                                                attrs: {
                                                                  name:
                                                                    "icon-trash-grey"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _vm.bsBetType === "PERMUTATION" ||
                                _vm.bsBetType === "NO_OPTION"
                                  ? _c(
                                      "div",
                                      { staticClass: "pmbs-rnrgroup" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouptitle" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Betslip.PM.Any_Order")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouprnrs" },
                                          _vm._l(
                                            _vm.selectedSRRunners,
                                            function(rnrdata) {
                                              return rnrdata &&
                                                rnrdata.finishes &&
                                                rnrdata.finishes.has("any")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pmbs-rnrgrouprnr"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "silknum silknum-" +
                                                            Math.floor(
                                                              rnrdata.runner.num
                                                            )
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              rnrdata.runner
                                                                .entrynumber
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.makeSrRunnerName(
                                                              rnrdata.runner
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "but-remove",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeSRSelection(
                                                                rnrdata.runner
                                                                  .id,
                                                                "any"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name:
                                                                "icon-trash-grey"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.bsBetType === "BANKER"
                                  ? _c(
                                      "div",
                                      { staticClass: "pmbs-rnrgroup" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouptitle" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Betslip.PM.1st_Place")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouprnrs" },
                                          _vm._l(
                                            _vm.selectedSRRunners,
                                            function(rnrdata) {
                                              return rnrdata &&
                                                rnrdata.finishes &&
                                                rnrdata.finishes.has("banker")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pmbs-rnrgrouprnr"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "silknum silknum-" +
                                                            Math.floor(
                                                              rnrdata.runner.num
                                                            )
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              rnrdata.runner
                                                                .entrynumber
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.makeSrRunnerName(
                                                              rnrdata.runner
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "but-remove",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeSRSelection(
                                                                rnrdata.runner
                                                                  .id,
                                                                "banker"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name:
                                                                "icon-trash-grey"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.bsBetType === "FLOATING_BANKER"
                                  ? _c(
                                      "div",
                                      { staticClass: "pmbs-rnrgroup" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouptitle" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Betslip.PM.Key"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouprnrs" },
                                          _vm._l(
                                            _vm.selectedSRRunners,
                                            function(rnrdata) {
                                              return rnrdata &&
                                                rnrdata.finishes &&
                                                rnrdata.finishes.has("banker")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pmbs-rnrgrouprnr"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "silknum silknum-" +
                                                            Math.floor(
                                                              rnrdata.runner.num
                                                            )
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              rnrdata.runner
                                                                .entrynumber
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.makeSrRunnerName(
                                                              rnrdata.runner
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "but-remove",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeSRSelection(
                                                                rnrdata.runner
                                                                  .id,
                                                                "banker"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name:
                                                                "icon-trash-grey"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.bsBetType === "BANKER" ||
                                _vm.bsBetType === "FLOATING_BANKER"
                                  ? _c(
                                      "div",
                                      { staticClass: "pmbs-rnrgroup" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouptitle" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Betslip.PM.With"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "pmbs-rnrgrouprnrs" },
                                          _vm._l(
                                            _vm.selectedSRRunners,
                                            function(rnrdata) {
                                              return rnrdata &&
                                                rnrdata.finishes &&
                                                rnrdata.finishes.has("any")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pmbs-rnrgrouprnr"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "silknum silknum-" +
                                                            Math.floor(
                                                              rnrdata.runner.num
                                                            )
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              rnrdata.runner
                                                                .entrynumber
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.makeSrRunnerName(
                                                              rnrdata.runner
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "but-remove",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeSRSelection(
                                                                rnrdata.runner
                                                                  .id,
                                                                "any"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name:
                                                                "icon-trash-grey"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.bsPool.category === "MULTIRACE POOL"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "pmbs-block" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "pmbs-bettitle clearafter" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.bsPool && _vm.bsPool.type
                                            ? _vm.pmTranslatePoolType(
                                                _vm.bsPool.type
                                              )
                                            : "-"
                                        ) +
                                        "\n              "
                                    ),
                                    _vm.getMultiRaceById(_vm.bsPool.legs[0].r)
                                      .usc === "ON"
                                      ? _c(
                                          "span",
                                          {
                                            class:
                                              "racetimeticker " +
                                              _vm.pmRaceClockCalculate(
                                                _vm.getMultiRaceById(
                                                  _vm.bsPool.legs[0].r
                                                ).tsstart,
                                                _vm.selectedMRTote.timestamp
                                              ).cssclass,
                                            staticStyle: { float: "right" },
                                            attrs: {
                                              "data-racetsstart": _vm.getMultiRaceById(
                                                _vm.bsPool.legs[0].r
                                              ).tsstart,
                                              "data-racedatastamp":
                                                _vm.selectedMRTote.timestamp,
                                              "data-raceusc": _vm.getMultiRaceById(
                                                _vm.bsPool.legs[0].r
                                              ).usc
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.pmRaceClockCalculate(
                                                  _vm.getMultiRaceById(
                                                    _vm.bsPool.legs[0].r
                                                  ).tsstart,
                                                  _vm.selectedMRTote.timestamp
                                                ).timetostarts
                                              )
                                            )
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "racetimeticker racetime-over",
                                            staticStyle: { float: "right" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getMultiRaceById(
                                                  _vm.bsPool.legs[0].r
                                                ).gsc
                                              )
                                            )
                                          ]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.bsPool.legs, function(leg, legIx) {
                                  return _c(
                                    "div",
                                    { staticClass: "pmbs-rnrgroup" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pmbs-rnrgrouptitle clearafter"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Betslip.PM.RaceNumber", {
                                                n: _vm.getMultiRaceById(leg.r)
                                                  .number
                                              })
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "pmbs-rnrgrouprnrs" },
                                        [
                                          !_vm.selectedMRRunners.hasOwnProperty(
                                            leg.r.toString()
                                          )
                                            ? _c("div", [_vm._v(" ")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.selectedMRRunners[
                                              leg.r.toString()
                                            ],
                                            function(runner) {
                                              return runner
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pmbs-rnrgrouprnr"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class:
                                                            "silknum silknum-" +
                                                            Math.floor(
                                                              runner.num
                                                            )
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              runner.entrynumber
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.makeMrRunnerName(
                                                              runner,
                                                              leg.r
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "but-remove",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeMRSelection(
                                                                leg.r,
                                                                runner.id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("icon", {
                                                            attrs: {
                                                              name:
                                                                "icon-trash-grey"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.availableRPTypes.indexOf(_vm.pooltype) === -1 &&
                      _vm.availableRCTypes.indexOf(_vm.pooltype) === -1 &&
                      _vm.availableMRTypes.indexOf(_vm.pooltype) === -1
                        ? _c("div", { staticClass: "STRAIGHT" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("Betslip.PM.Not_Implemented")) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  staticClass: "fixed_footer_sep",
                  class: { not_visible: _vm.placeBetStatus },
                  style: _vm.betslipBottomHolderHeight
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "betslipFooter", staticClass: "betslip_actions" },
                  [
                    _vm.bsPool && !_vm.placeBetStatus
                      ? [
                          _vm.isValidationVisible &&
                          _vm.betslipValidity &&
                          !_vm.betslipValidity.isValid
                            ? _c(
                                "div",
                                { staticClass: "pm-msgblock validations" },
                                [
                                  _c("div", { staticClass: "pm-msgtitle" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Betslip.PM.Wager_Validation")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    Object.entries(
                                      _vm.betslipValidity.invalids
                                    ),
                                    function(ref, vldDataIx) {
                                      var vInvldKey = ref[0]
                                      var vInvldData = ref[1]
                                      return _c(
                                        "div",
                                        { staticClass: "pm-msgtext" },
                                        [
                                          vInvldKey === "ZERO_RUNNERS"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.ZERO_RUNNERS"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "TOO_FEW_RUNNERS"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.TOO_FEW_RUNNERS"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "RC_ZERO_RUNNER4FINISH"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.RC_ZERO_RUNNER4FINISH"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "ZERO_RUNNER4ANY"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.ZERO_RUNNER4ANY"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "TOO_FEW_RUNNER4ANY"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.TOO_FEW_RUNNER4ANY"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "TOO_MANY_RUNNER4ANY"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "TOO_MANY_RUNNER4ANY"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "ZERO_RUNNER4BANKER"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.ZERO_RUNNER4BANKER"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "TOO_MANY_BANKERS"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.TOO_MANY_BANKERS"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "MR_RACE_WITHOUT_RUNNER"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.MR_RACE_WITHOUT_RUNNER"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "STAKE_ZERO"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_ZERO"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "STAKE_LIMIT_MINUNITSTAKE"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_LIMIT_MINUNITSTAKE",
                                                      {
                                                        n: vInvldData.limit,
                                                        currency:
                                                          _vm.currencySymbol
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "STAKE_LIMIT_MAXUNITSTAKE"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_LIMIT_MAXUNITSTAKE",
                                                      {
                                                        n: vInvldData.limit,
                                                        currency:
                                                          _vm.currencySymbol
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "STAKE_LIMIT_MINTOTALSTAKE"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_LIMIT_MINTOTALSTAKE",
                                                      {
                                                        n: vInvldData.limit,
                                                        currency:
                                                          _vm.currencySymbol
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "STAKE_LIMIT_MAXTOTALSTAKE"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_LIMIT_MAXTOTALSTAKE",
                                                      {
                                                        n: vInvldData.limit,
                                                        currency:
                                                          _vm.currencySymbol
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "STAKE_LIMIT_STAKEINCREMENT"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_LIMIT_STAKEINCREMENT",
                                                      {
                                                        n: vInvldData.limit,
                                                        currency:
                                                          _vm.currencySymbol
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "STAKE_LIMIT_MINSTAKEONLY"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.STAKE_LIMIT_MINSTAKEONLY",
                                                      {
                                                        n: vInvldData.limit,
                                                        currency:
                                                          _vm.currencySymbol
                                                      }
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey === "BET_NOT_CALCULATED"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.BET_NOT_CALCULATED"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "NOT_ALLOWED_FOR_BETTING"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.NOT_ALLOWED_FOR_BETTING"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "BETTING_DATA_IS_LOADING"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Betslip.PM.BETTING_DATA_IS_LOADING"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "EXCLUDED_FOR_BETTING"
                                            ? [
                                                vInvldData.reason.includes(
                                                  "PEND"
                                                ) &&
                                                !vInvldData.reason.includes(
                                                  "SUSP"
                                                )
                                                  ? _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "Account.Ovelay.Pending.Investigation"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : vInvldData.reason.includes(
                                                      "SUSP"
                                                    ) &&
                                                    !vInvldData.reason.includes(
                                                      "PEND"
                                                    )
                                                  ? _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "Account.Ovelay.Suspension"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : vInvldData.reason.includes(
                                                      "SUSP"
                                                    ) &&
                                                    vInvldData.reason.includes(
                                                      "PEND"
                                                    )
                                                  ? _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "Account.Ovelay.Pending.Investigation.and.Suspension"
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _c("p", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "BetSlip.placement.error." +
                                                              vInvldData.reason
                                                          )
                                                        )
                                                      }
                                                    })
                                              ]
                                            : vInvldKey ===
                                              "NATIVE_APP_REQUIRED_ON_MOBILE"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "appInstaller.addTo.content"
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "NATIVE_APP_GEOLOCATION_FAIL"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "nativeApp.failedGeolocation.contect." +
                                                        _vm.state
                                                    )
                                                  )
                                                )
                                              ]
                                            : vInvldKey ===
                                              "IN_BROWSER_GEOLOCATION_FAIL"
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "nativeApp.failedGeolocation.contect." +
                                                        _vm.state
                                                    )
                                                  )
                                                )
                                              ]
                                            : [_vm._v(_vm._s(vInvldKey))]
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "pm-msgblock-close",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.showBetslipValidation(
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticStyle: { display: "none" } }, [
                            _vm._v(
                              "\n            stake: " +
                                _vm._s(_vm.stake) +
                                "\n            stakeStr: " +
                                _vm._s(_vm.stakeStr) +
                                "\n            betslipValidity: " +
                                _vm._s(_vm.betslipValidity) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pmbs-stakes line dark" },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c("v-flex", [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "pmbs-numblock money editable"
                                      },
                                      [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Betslip.PM.Bet_Amount")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "currency" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Betslip.PM.Currency")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.stakeStr,
                                              expression: "stakeStr"
                                            }
                                          ],
                                          staticClass: "numinp",
                                          attrs: { type: "tel" },
                                          domProps: { value: _vm.stakeStr },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.stakeStr = $event.target.value
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", [
                                    _c(
                                      "label",
                                      { staticClass: "pmbs-numblock" },
                                      [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(_vm.$t("Betslip.PM.Bets"))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        !_vm.isCalculating
                                          ? _c(
                                              "span",
                                              { staticClass: "numinp" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.numberOfCombinations
                                                  )
                                                )
                                              ]
                                            )
                                          : _c("span", [_c("loader")], 1)
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", [
                                    _c(
                                      "label",
                                      { staticClass: "pmbs-numblock money" },
                                      [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Betslip.PM.Ticket_Cost")
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "currency" },
                                          [_vm._v("$")]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isCalculating
                                          ? _c("input", {
                                              staticClass: "numinp",
                                              attrs: {
                                                type: "number",
                                                readonly: "readonly"
                                              },
                                              domProps: {
                                                value: _vm.stakeTotal
                                              }
                                            })
                                          : _c("span", [_c("loader")], 1)
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("geolocation-indicator"),
                    _vm._v(" "),
                    !_vm.placeBetStatus
                      ? _c("div", { staticClass: "pmbs-btnctrls" }, [
                          _vm.isLoggedIn
                            ? _c(
                                "div",
                                { staticClass: "pmbs-btnctrls-group tac" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "placebetbtn",
                                      attrs: {
                                        color: "primary",
                                        disabled:
                                          !_vm.isLoggedIn ||
                                          (_vm.desktopAndAbove &&
                                            !_vm.isGeolocated),
                                        id: "btnPlaceBet"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.placeBet()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("BetSlip.btn.PlaceBet"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "pmbs-btnctrls-group tac" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "placebetbtn",
                                      attrs: {
                                        color: "primary",
                                        id: "btnLogInAndPlaceBet"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.popUpLogIn()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("BetSlip.btn.msg.LogIn"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "pmbs-btnctrls-group pmbs-btnctrls-group-clearall",
                              attrs: {
                                disabled:
                                  Object.values(_vm.selectedSRRunners)
                                    .length === 0 &&
                                  Object.values(_vm.selectedMRRunners)
                                    .length === 0
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "but-remove pmbs-clearall",
                                  attrs: { flat: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.clearBetslip()
                                    }
                                  }
                                },
                                [
                                  _c("icon", {
                                    attrs: { name: "icon-trash-grey" }
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("BetSlip.selection.btn.clearall")
                                    )
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.placeBetStatus
                  ? [
                      _vm.placeBetStatus === "L" ||
                      _vm.placeBetStatus.State === 0
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "pm-msgblock info tac placing_bet"
                              },
                              [
                                _c("div", { staticClass: "pm-msgtitle" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("Betslip.PM.Placing_Bet"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "pm-msgtext" },
                                  [_c("loader")],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm.placeBetStatus === "P"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "pm-msgblock success bet_placed" },
                              [
                                _vm.brandKey === "boyd"
                                  ? _c("a", [
                                      _c("img", {
                                        staticClass: "bet_placed_img",
                                        attrs: {
                                          src: require("@/assets/images/betslip/PlacedBetSign.svg"),
                                          alt: "Betslip"
                                        }
                                      })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brandKey === "dn" ||
                                _vm.brandKey === "dnw" ||
                                _vm.brandKey === "circa"
                                  ? _c(
                                      "a",
                                      { staticClass: "bet_placed_icon" },
                                      [_c("v-icon", [_vm._v("done")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "pm-msgtitle" }, [
                                  _c("div", { staticClass: "betplaced-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "Betslip.PM.You_Successfully_placed",
                                          {
                                            n: _vm.numberOfCombinations,
                                            s:
                                              _vm.numberOfCombinations > 1
                                                ? "s"
                                                : ""
                                          }
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "goodLuck_text" }, [
                                    _vm._v("Good Luck!")
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "pmbs-btnctrls" }, [
                              _c(
                                "div",
                                { staticClass: "pmbs-btnctrls-group tac" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary dismiss" },
                                      on: {
                                        click: function() {
                                          _vm.confirmBetslipMessage(true)
                                          _vm.clearBetslip()
                                          _vm.toggleBetslip()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Betslip.PM.Dismiss"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "gray lighten-1 keep-selections"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return function() {
                                            _vm.confirmBetslipMessage(false)
                                            _vm.toggleBetslip()
                                          }.apply(null, arguments)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Betslip.PM.Keep_Selections")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm.placeBetStatus === "F"
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "pm-msgblock validations errors" },
                              [
                                _c("div", { staticClass: "pm-msgtitle" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Betslip.PM.Bet_Placement_Failed")
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "pmbs-btnctrls" }, [
                              _c(
                                "div",
                                { staticClass: "pmbs-btnctrls-group tac" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmBetslipMessage(
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("BetSlip.quick.btn.OK"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _vm.placeBetStatus.StatusText
                        ? _c("div", [
                            _c("div", { staticClass: "pm-msgblock info" }, [
                              _c("div", { staticClass: "pm-msgtitle" }, [
                                _vm._v(_vm._s(_vm.placeBetStatus.StatusText)),
                                _vm.placeBetStatus.StatusText.slice(-1) !== "."
                                  ? _c("span", [_vm._v(".")])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pmbs-btnctrls" }, [
                              _c(
                                "div",
                                { staticClass: "pmbs-btnctrls-group tac" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmBetslipMessage(
                                            _vm.placeBetStatus.State === -2
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("BetSlip.quick.btn.OK"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "pm-msgblock validations errors" },
                              [
                                _c("div", { staticClass: "pm-msgtitle" }, [
                                  _vm._v(_vm._s(_vm.$t("Betslip.PM.Error")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "pmbs-btnctrls" }, [
                              _c(
                                "div",
                                { staticClass: "pmbs-btnctrls-group tac" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmBetslipMessage(
                                            false
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("BetSlip.quick.btn.OK"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ],
      _vm._v(" "),
      true === 11
        ? _c("div", [
            _vm._v("\n    selectedSRRunners: " + _vm._s(_vm.selectedSRRunners)),
            _c("br"),
            _vm._v("\n    selectedMRRunners: " + _vm._s(_vm.selectedMRRunners)),
            _c("br"),
            _vm._v("\n    bsPool: " + _vm._s(_vm.bsPool)),
            _c("br"),
            _vm._v("\n    bsBetType: " + _vm._s(_vm.bsBetType)),
            _c("br"),
            _vm._v(
              "\n    placeBetStatus: " + _vm._s(_vm.placeBetStatus) + "\n  "
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc4e948c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc4e948c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parimutuel/betting/betslip.vue
// module id = null
// module chunks = 